import React from 'react';
import PropTypes from 'prop-types';
import './ThumbUpIcon.scss';

const ThumbUpIcon = ({ isActive, className }) => {
    return (
        <svg
            className={`thumbup-icon ${
                isActive ? 'active' : 'inactive'
            } ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
        >
            <path
                id="thumbup_shape"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2721 15.6668C13.1225 15.6867 14.0393 15.313 14.5064 14.4167H14.1691C13.7075 14.4167 13.3333 14.0468 13.3333 13.5833C13.3333 13.1231 13.7027 12.75 14.1691 12.75H15.0039C15.0727 12.4857 15.1465 12.2018 15.2204 11.9167H14.5858C14.1242 11.9167 13.75 11.5468 13.75 11.0833C13.75 10.6231 14.1194 10.25 14.5858 10.25H15.651C15.7479 9.87393 15.8121 9.62397 15.8153 9.61107C15.8943 9.24523 15.6936 8.99975 15.3019 8.99975L12.2944 8.99955C11.0137 8.99946 10.0695 7.8573 10.3225 6.59441C10.3311 6.55151 10.5712 5.33899 10.587 5.24958C10.7592 4.27415 10.8401 3.57723 10.8335 3.18059L10.8335 3.12268C10.838 2.87388 10.6866 2.6087 10.2881 2.29816C10.2433 2.26326 9.95031 2.08591 9.95031 2.08591L7.54774 7.27901C7.10248 8.24143 6.06114 8.93653 5 8.99588V15.6701C7.644 15.6694 10.9486 15.6682 11.2721 15.6668ZM3.33333 9H1.66635L1.66667 15.6708C1.66667 15.6708 2.34124 15.6707 3.33333 15.6705V9ZM1.66635 17.3333C0.746048 17.3333 0 16.5899 0 15.6708V8.99586C0 8.07767 0.746862 7.33334 1.66635 7.33334H4.8533C5.31524 7.33334 5.83617 6.97664 6.03511 6.5792C6.23405 6.18175 8.62704 0.976813 8.62704 0.976813C8.92032 0.342885 9.67722 0.0676662 10.3091 0.386334C10.3091 0.386334 10.9158 0.674345 11.3126 0.983537C12.0493 1.55763 12.5155 2.28529 12.4999 3.15274C12.5091 3.70175 12.4099 4.51063 12.2282 5.5394C12.1797 5.81432 11.9563 6.92345 11.9563 6.92345C11.911 7.14997 12.0624 7.33287 12.2945 7.33288L15.302 7.33308C16.7521 7.33308 17.7465 8.55418 17.4474 9.95223C17.4383 9.99938 16.3882 14.216 16.1984 14.7055C15.4913 16.6194 13.852 17.3614 11.2541 17.3333C10.0618 17.3392 1.66635 17.3333 1.66635 17.3333Z"
            />
        </svg>
    );
};

ThumbUpIcon.defaultProps = {
    isActive: false,
    className: '',
};

ThumbUpIcon.propTypes = {
    isActive: PropTypes.bool,
    className: PropTypes.string,
};

export default ThumbUpIcon;
